module.exports = __webpack_public_path__ + "static/media/zhudonghuoke.fa6d3cc4.png";